import { type FabricMarkShowFaceIdApi, showFaceId } from './show-faceid.js';
import {
  type FabricMarkShowFaceIdV5Api,
  showFaceIdV5,
} from './show-faceid-v5.js';
import { type FabricMarkShowIdCardApi, showIdCard } from './show-idcard.js';

export type FabricMarkApi = {
  /**
   * 展示人脸识别
   */
  showFaceId: FabricMarkShowFaceIdApi;
  showFaceIdV5: FabricMarkShowFaceIdV5Api;
  /**
   * 展示身份证正反面识别
   */
  showIdCard: FabricMarkShowIdCardApi;
};

export const fabricMark: FabricMarkApi = {
  showFaceId,
  showFaceIdV5,
  showIdCard,
};
